import type {
  OrganizationSelectOptionItemData,
  OrganizationSelectOptionItemValue,
  OrganizationSelectProps,
} from "./organization-select.type";

import { useTranslation } from "react-i18next";

import QueryableSelect from "@/modules/queryable-select";

import OrganizationSelectOption from "./organization-select-option";
import { ORGANIZATION_FIELD_NAME } from "./organization-select.constant";

const OrganizationSelect = ({
  hideLabel,
  ...props
}: OrganizationSelectProps) => {
  const { t } = useTranslation();
  const label = t("global:organization");

  return (
    <QueryableSelect<
      OrganizationSelectOptionItemValue,
      OrganizationSelectOptionItemData
    >
      data-testid="organization-select"
      name={ORGANIZATION_FIELD_NAME}
      model="organizations"
      filterBy="name"
      fields={["id", "name"]}
      label={hideLabel ? undefined : label}
      placeholder={label}
      optionFormat={OrganizationSelectOption}
      rules={[{ required: true }]}
      {...props}
    />
  );
};

export default OrganizationSelect;
